import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface InvoicePromptDialogData {
  prompt: string;
}

@Component({
  selector: 'app-invoice-prompt-dialog',
  templateUrl: './invoice-prompt.dialog.html',
  styleUrls: ['./invoice-prompt.dialog.scss']
})
export class InvoicePromptDialogComponent {
  public promptText: string;

  constructor(
    private dialogRef: MatDialogRef<InvoicePromptDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InvoicePromptDialogData
  ) {
    this.promptText = data?.prompt ?? '';
  }

  close(): void {
    this.dialogRef.close();
  }

  submit(): void {
    const trimmed = (this.promptText || '').trim();
    this.dialogRef.close(trimmed);
  }
}
